import Link from 'next/link';
import { isLinkAbsolute } from '../../util/DataUtil';

const correctInternalLink = (uri) => {
  if (!uri) return '/';
  if (uri.includes('internal:')) return uri.substring(9);
  return uri;
};

const FieldLinkButton = ({
  link,
  bgColor = '',
  hasCtaArrow = false,
  pathname = false,
  blockTypeClass = '',
  primaryText = '',
  onClick = null,
  dangerousHTML = null,
}) => {
  const text = primaryText || link?.title;
  if (!text && !dangerousHTML) return null;

  const className = `a-${blockTypeClass}-button cta-link ${bgColor ? bgColor.toLowerCase() : ''} ${hasCtaArrow ? 'arrow' : ''} ${pathname ? 'hover' : ''}`;

  if (onClick) {
    return (
      <div className="cta-container">
        <a
          className={className}
          onClick={onClick}
          style={{ cursor: 'pointer' }}
          {...(dangerousHTML ? { dangerouslySetInnerHTML: { __html: dangerousHTML } } : {})}
        >
          {dangerousHTML ? null : text}
        </a>
      </div>
    );
  }

  const href = correctInternalLink(link.uri);

  return (
    <div className="cta-container">
      <Link href={href} passHref legacyBehavior>
        <a
          target={isLinkAbsolute(link.uri) ? '_blank' : '_self'}
          className={className}
        >
          {text}
        </a>
      </Link>
    </div>
  );
};

export default FieldLinkButton;
